import { useNode } from "@craftjs/core";
import { TextField, FormGroup, FormControlLabel, Switch } from "@mui/material";
import { EventFiltersSettings } from "@components/EventFilterSettings";

const BasicCarouselSettings = () => {
  const {
    actions: { setProp },
    title,
    showSeeMore,
    actionButtonText,
    isPersistent,
    isMostWatched,
  } = useNode((node) => ({
    title: node.data.props.title,
    showSeeMore: node.data.props.showSeeMore,
    actionButtonText: node.data.props.actionButtonText,
    isPersistent: node.data.props.isPersistent || false,
    isMostWatched: node.data.props.isMostWatched || false,
  }));

  const handleShowSeeMoreChange = (checked: boolean) => {
    setProp((props: any) => (props.showSeeMore = checked));
  };

  const handlePersistentChange = (checked: boolean) => {
    setProp((props: any) => (props.isPersistent = checked));
  };

  const handleMostWatchedChange = (checked: boolean) => {
    setProp((props: any) => (props.isMostWatched = checked))
  }

  return (
    <div className="flex flex-col gap-4">
      <TextField
        fullWidth
        label="Title"
        value={title}
        onChange={(e) =>
          setProp((props: any) => (props.title = e.target.value))
        }
      />

      {/* Persistent Carousel Switch */}
      { !isMostWatched && (<FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={isPersistent}
              onChange={(e) => handlePersistentChange(e.target.checked)}
            />
          }
          label="Persistent Carousel"
        />
      </FormGroup>
      )}

      {/* MostWatched Carousel Switch */}
      { !isPersistent && ( <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={isMostWatched}
              onChange={(e) => handleMostWatchedChange(e.target.checked)}
            />
          }
          label="Most Watched Carousel"
        />
      </FormGroup>)}

      {/* See More Switch */}
      { !isPersistent && !isMostWatched && (
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={showSeeMore}
                onChange={(e) => handleShowSeeMoreChange(e.target.checked)}
              />
            }
            label="Show See More"
          />
        </FormGroup>
      )}
      
      {!isPersistent && !isMostWatched && showSeeMore && (
        <TextField
          fullWidth
          label="Action Button Text"
          value={actionButtonText}
          onChange={(e) =>
            setProp((props: any) => (props.actionButtonText = e.target.value))
          }
        />
      )}

      {isPersistent && (
        // When persistent mode is enabled, show persistent-specific filter options
        <EventFiltersSettings includePersistentIDOptions />
      )}
      {!isPersistent && !isMostWatched && (
        // Otherwise, show the standard event filters
        <EventFiltersSettings
        includeCategories={true}
        includeEventStatus={true}
        includeKeywords={true}
        includeDateRange={true}
        />
      )}
    </div>
  );
};

export { BasicCarouselSettings };
